import state from './moduloModalsState';
import mutations from './moduloModalsMutations';
import * as actions from './moduloModalsActions';
import * as getters from './moduloModalsGetters';

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
};
